import { connect } from 'react-redux';
import CalendarTime from 'components/CalendarTime/CalendarTime';
import { ONE_DAY, FIFTEEN_MINUTES } from 'constants/Calendar';
import { endOfDay } from 'utils/calendar-utils';
import { injectIntl, defineMessages } from 'react-intl';
import _get from 'lodash/get';

const messages = defineMessages({
  now: { id: 'components.calendarEvent.now', defaultMessage: 'Now' },
  inOneMinute: { id: 'components.calendarEvent.inOneMinute', defaultMessage: 'In 1 minute' },
  inNMinutes: { id: 'components.calendarEvent.inNMinutes', defaultMessage: 'In {numberOfMinutes} minutes' },
});

const getMinutesUntilStart = (startDate, endDate) => {
  if (!startDate || !endDate) return -999;
  var diff = endDate.getTime() - startDate.getTime();
  return Math.ceil(diff / 60000);
}

const isMeetingNow = (startDate, endDate) => {
  if (!startDate || !endDate) return false;
  return ((startDate.getTime() < new Date().getTime()) && (endDate.getTime() > new Date().getTime()));
}

const mapStateToProps = (state, ownProps) => {
  const event = ownProps.event;
  let totalDays = 0;
  let isFirstDay = false;
  let isLastDay = false;
  let isAllDay = false;
  let upcomingTime = null;
  const minutesUntilStart = getMinutesUntilStart(new Date(), event?.startDate);
  const upcomingInMinutes = (minutesUntilStart < 15 && minutesUntilStart >= 0) ? minutesUntilStart : isMeetingNow(event?.startDate, event?.endDate) ? 0 : null;
  if (upcomingInMinutes === 0) {
    upcomingTime = ownProps.intl.formatMessage(messages.now);
  } else if (upcomingInMinutes === 1) {
    upcomingTime = ownProps.intl.formatMessage(messages.inOneMinute);
  } else if (upcomingInMinutes) {
    upcomingTime = ownProps.intl.formatMessage(messages.inNMinutes, { numberOfMinutes: upcomingInMinutes });
  }

  if (ownProps.noUpcoming) {
    upcomingTime = null;
  }

  const nowTime = new Date();
  const startDateTime = _get(event, 'start.dateTime');
  const endDateTime = _get(event, 'end.dateTime');
  const startDateOnly = _get(event, 'start.date');
  const endDateOnly = _get(event, 'end.date');

  const startDate = _get(event, 'startDate');
  const endDate = _get(event, 'endDate');

  const startTime = _get(event, 'formattedStartTime');
  const endTime = _get(event, 'formattedEndTime');

  const formattedStartDate = _get(event, 'formattedStartDate');
  const formattedEndDate = _get(event, 'formattedEndDate');

  const meetingStart = startDateTime ? startDate.getTime() : endOfDay(startDateOnly);
  const meetingEnd = endDateTime ? endDate.getTime() : endOfDay(endDateOnly);
  const meetingLengthInDaysExact = (meetingEnd - meetingStart) / ONE_DAY;

  const meetingLengthInDays = Math.ceil(meetingLengthInDaysExact);
  const meetingDay = new Date(ownProps.targetDay);
  if ((meetingDay.getTime() - nowTime.getTime()) > FIFTEEN_MINUTES) {
    // The meeting is technically happening "now" but don't show that if the day is in the future
    upcomingTime = null;
  }

  let currentDay = Math.max(Math.abs(Math.ceil((meetingDay.getTime() - meetingStart) / ONE_DAY)), 1);

  let startDateNumber;
  let endDateNumber;
  let oneFullDay;

  if (startDate) {
    startDateNumber = startDateTime ? startDate.getDate() : startDate.getUTCDate();
  }
  if (endDate) {
    endDateNumber = endDateTime ? endDate.getDate() : endDate.getUTCDate() - 1;
  }

  if (startDate) {
    oneFullDay = startDate.getHours() === 0 && meetingLengthInDaysExact === 1;
  }
  if (oneFullDay) { // Outlook reports single full day meetings as going from timestamp 0 on day 1 to 0 on day 2
    isAllDay = true;
  }

  if (
    meetingLengthInDays > 1
  ) {
    totalDays = meetingLengthInDays;
    if (meetingDay.getDate() === new Date(new Date(endDate).setMilliseconds(-1)).getDate()) {
      currentDay = totalDays;
    }
    isFirstDay = currentDay === 1 && startDate.getHours() !== 0;
    isLastDay = totalDays === currentDay && endDate.getHours() !== 0;
    if (!isFirstDay && !isLastDay) {
      isAllDay = true;
    }
  } else if (!oneFullDay && startDateNumber !== endDateNumber) {
    isFirstDay = meetingDay.getDate() === startDate.getDate();
    if (endDate) {
      isLastDay = meetingDay.getDate() === endDate.getDate();
    }
  }

  if (!startDateTime) {
    isAllDay = true;
  }

  return {
    endTime,
    formattedEndDate,
    formattedStartDate,
    isAllDay,
    isFirstDay,
    isLastDay,
    startTime,
    upcomingTime
  };
};

const mapDispatchToProps = () => ({});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CalendarTime)
);
